import { useState, useEffect } from 'react';
import API from '../lib/api';

import { Grid, GridCol, Container, Center, Paper } from '@mantine/core';

export function FoxFiascoPage() {
	const [counts, setCounts] = useState([]);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		const fetchStations = async () => {
			const r = await API.post('recording/getFoxFiascoData', { limit: 5 });
			if (r.error) {
				console.error(r.error);
				return;
			}
			setCounts(r);
			setLoading(false);
		}
		fetchStations();
	}, []);

	if (loading) {
		return <h1>Loading...</h1>;
	}

	return (
		<>
			<Center>
				<Paper w={1000} shadow="sm" p="md" m="md">
					<h1>Fox Fiasco</h1>
					{counts.countWithFingerprints} of {counts.count}
				</Paper>
			</Center>
		</>
	);
}